export default __webpack_public_path__ + "static/media/notif_resolved_closed.1fbd14c3.svg";